import { toArray ,isString} from 'lodash'
import Vue from 'vue'
import Vuex, { Module, ActionContext } from 'vuex'
import { http, mapCategorys } from './core/utils'
import { Route } from 'vue-router';

Vue.use(Vuex)

const api = {
  queryCategorys: '//sccapi.czj100.com/scc-api/fchild/applyJoin/queryCategorys.do',
  queryCollapse: '//svsesapi.haiziwang.com/svses-api/api/queryCollapse.do' // 服务反向聚合查询接口
}

interface AppState {
  allCategoryList: any[]
  allCollapseList: any[]
}

const vuexOptions = {
  state: () => ({
    allCategoryList: [],
    allCollapseList: []
  }),
  mutations: {
    setAllCategorys(state: AppState, payload: any) {
      state.allCategoryList = payload
    },
    setAllCollapse(state: AppState, payload: any) {
      state.allCollapseList = payload
    }
  },
  getters: {},
  actions: {
    async getAllCategorylist(context: ActionContext<AppState, any>) {
      const allCategoryList = context.state.allCategoryList
      if (allCategoryList && allCategoryList.length === 0) {
        const res: ResponseCode = await http.get(api.queryCategorys)
        if (res && res.code == 1) {
          let list: any[] = toArray(res.data)
          const allList = mapCategorys(list)
          context.commit('setAllCategorys', allList)
          return allList
        }
      } else {
        return allCategoryList
      }
      context.commit('setAllCategorys', [])
      return []
    },
    async getAllCollapselist(context: ActionContext<AppState, any>, params: { collapseType: number; businessId: number[] }) {
      const allCollapseList = context.state.allCollapseList
      if (allCollapseList && allCollapseList.length === 0) {
        const res: ResponseCode = await http.post(api.queryCollapse, params)
        if (res && res.code == 1) {
          let list: any[] = toArray(res.data)
          context.commit('setAllCollapse', list)
          return list
        }
      } else {
        return allCollapseList
      }
      context.commit('setAllCollapse', [])
      return []
    }
  }
}

export const appStore = new Vuex.Store(vuexOptions)

/**
 * 
 * @param to 路由或者自定义module名称
 * @param store 数据
 * @param isCache 是否缓存store
 */
export function registerModule(to: Route | string, store: Module<any, any>, isCache = false) {
  let name = ''
  let keepAlive = isCache;
  if(isString(to)) {
    name = to
  } else if(to && to.name){
    name = to.name
    keepAlive = to?.meta?.keepAlive
  }
  if(name) {
    if(appStore.hasModule(name)){
      if(!keepAlive) {
        appStore.unregisterModule(name);
        appStore.registerModule(name, store)
      } 
    } else {
      appStore.registerModule(name, store)
    }
  }
}
